import {
  DiamondsFourIcon,
  DownloadSimpleIcon,
  IconProps,
  InfoIcon,
  LayoutIcon,
  NoteIcon,
  PaletteIcon,
  ReadCvLogoIcon,
  ShareFatIcon,
  TextTIcon,
  TranslateIcon,
  TrendUpIcon,
} from "@phosphor-icons/react";
import { Button, ButtonProps, Tooltip } from "@reactive-resume/ui";

export type MetadataKey =
  | "template"
  | "layout"
  | "typography"
  | "theme"
  | "page"
  | "locale"
  | "sharing"
  | "statistics"
  | "export"
  | "notes"
  | "information";

export const getSectionIcon = (id: MetadataKey, props: IconProps = {}) => {
  switch (id) {
    // Left Sidebar
    case "notes": {
      return <NoteIcon size={18} {...props} />;
    }
    case "template": {
      return <DiamondsFourIcon size={18} {...props} />;
    }
    case "layout": {
      return <LayoutIcon size={18} {...props} />;
    }
    case "typography": {
      return <TextTIcon size={18} {...props} />;
    }
    case "theme": {
      return <PaletteIcon size={18} {...props} />;
    }
    case "page": {
      return <ReadCvLogoIcon size={18} {...props} />;
    }
    case "locale": {
      return <TranslateIcon size={18} {...props} />;
    }
    case "sharing": {
      return <ShareFatIcon size={18} {...props} />;
    }
    case "statistics": {
      return <TrendUpIcon size={18} {...props} />;
    }
    case "export": {
      return <DownloadSimpleIcon size={18} {...props} />;
    }
    case "information": {
      return <InfoIcon size={18} {...props} />;
    }

    default: {
      return null;
    }
  }
};

type SectionIconProps = ButtonProps & {
  id: MetadataKey;
  name: string;
  icon?: React.ReactNode;
};

export const SectionIcon = ({ id, name, icon, ...props }: SectionIconProps) => (
  <Tooltip side="left" content={name}>
    <Button size="icon" variant="ghost" className="size-8 rounded-full" {...props}>
      {icon ?? getSectionIcon(id, { size: 14 })}
    </Button>
  </Tooltip>
);
